import { WebApiService } from './plugins/webApiService';
import ProjectBaseService from './projects/base/service/ProjectBaseService'

export default class apiDataSourceMain {
	ProjectBaseService: ProjectBaseService;
	constructor(cookieName?: string) {
		this.ProjectBaseService = new ProjectBaseService(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
